import React from 'react'
import {useLocation} from 'react-router-dom'
import '../styles/acknowledgementStyles.css'
import {BlueGradientBackground} from '../components/AuthForm'
import {getFormattedDateTime} from '../utils/util'
import {ReactComponent as CalendarIcon} from '../assets/calendar-day.svg'
import keapLogo from '../assets/keap-white.png'
import logo from '../assets/thryv-logo-white-letters.svg'
import thanksForYourPurchase from '../assets/payment-completed-image.png'

const HeaderDivider = () => (
  <div
    style={{
      height: '36px',
      marginInline: '16px',
      flexShrink: 0,
      border: '1px solid rgba(255, 255, 255, 0.1)',
    }}
  />
)

export const AcknowledgementComponent = () => {
  let data = useLocation()

  const Appointment = ({appointment, title}) => (
    <div className="appointment-card d-flex flex-row w-100">
      <p className="m-0 appointment-title" color="#231F20">
        {title}
      </p>
      <p className="m-0 appointment-time">
        {': '}
        <span className="appointment-datetime">
          {getFormattedDateTime(appointment)}
        </span>
      </p>
    </div>
  )

  return (
    <>
      <BlueGradientBackground
        showLogo={false}
        backgroundHexColor="linear-gradient(to bottom, #171d37, #6474a9)"
        className="ack-bg"
      />
      <section className="acknowledgement-container">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 0,
            flexShrink: 0,
          }}
        >
          <img src={logo} alt="Thryv Logo" className="header-logo" />
          <HeaderDivider />
          <img src={keapLogo} alt="Keap Logo" className="header-logo" />
        </div>
        <div className={`acknowledgement-card`}>
          <div className="acknowledgement-image-wrapper">
            <img src={thanksForYourPurchase} alt="Thanks for the purchase" />
          </div>
          <div className="acknowledgement-content">
            <p className="acknowledgement-title">Thank You for Your Payment!</p>
            <p className="acknowledgement-subtitle">
              Your payment information has been successfully updated. We will
              use this information to bill your Thryv subscriptions each month.
              You can update your billing information through the My Account
              page.
            </p>
            <div className="next-steps-list">
              <p className="next-steps-list-title">Next steps from Thryv:</p>
              <ul>
                <li>A dedicated Thryv Success Manager will reach out</li>
                <li>Mobile app access will be enabled</li>
                <li>Online listings will be updated and secured</li>
                <li>CRM configuration will begin</li>
              </ul>
            </div>
            <p className="next-steps-list-subtitle">
              We appreciate your business and look forward to helping you grow!
            </p>
            {data.state?.scheduleDetails?.apptDetails?.length > 0 && (
              <>
                {' '}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    columnGap: '12px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      columnGap: '12px',
                      alignItems: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <CalendarIcon height="20px" width="22px" color="#FF5000" />
                    <p
                      style={{
                        fontWeight: 600,
                        fontSize: '16px',
                      }}
                      className="m-0"
                    >
                      Your Upcoming Appointments
                    </p>
                  </div>
                  {data.state.scheduleDetails.apptDetails.map(item => {
                    let appointmentTitle = 'Website Design Call'
                    if (item.type === 'onboarding') {
                      appointmentTitle =
                        data.state?.kickoffCallLabel ||
                        (data.state?.influencer_name
                          ? 'Marketing Center Kickoff Call'
                          : 'SEO/ Leads / Social Ads Kickoff Call')
                    }
                    return (
                      <Appointment
                        title={appointmentTitle}
                        key={item.type}
                        appointment={item}
                      />
                    )
                  })}
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  )
}
